import { Breakpoint, breakpoints } from "./useBreakpoint";

type ResponsiveObject<T> = { [key in Breakpoint]?: T };

export type ResponsiveValue<T> = T | ResponsiveObject<T>;

export function getResponsiveValue<T>(
	responsiveValue: ResponsiveValue<T>,
	currentBreakpoint: Breakpoint
): T | undefined {
	if (
		typeof responsiveValue !== "object" ||
		(responsiveValue &&
			typeof responsiveValue === "object" &&
			!Object.keys(responsiveValue).reduce(
				(hasBreakpointKey, current) => {
					if (breakpoints.includes(current as any)) return true;
					return hasBreakpointKey;
				},
				false
			))
	)
		return responsiveValue as T;

	let res: T | undefined;
	for (let breakpoint of breakpoints) {
		const indexInBreakpoints = breakpoints.indexOf(breakpoint);
		const indexInBreakpointsCurrent =
			breakpoints.indexOf(currentBreakpoint);
		if (indexInBreakpoints <= indexInBreakpointsCurrent) {
			res = (responsiveValue as ResponsiveObject<T>)[breakpoint] || res;
		}
	}

	return res;
}
